import { Component, computed, HostBinding, inject, input } from '@angular/core';
import { CrntButtonAlt } from '@essent/current-web-angular';
import {
  CoreJssProxyModule,
  ImageField,
  LinkField,
  RichTextField,
  TextField,
} from '@core/jss-proxy';
import { CommonUiUtilityComponentsModule } from '@legacy/common-ui-utility-components';
import { JssPlatformService } from '@core/jss-platform';

@Component({
  selector: 'wl-information-card',
  standalone: true,
  imports: [CommonUiUtilityComponentsModule, CoreJssProxyModule, CrntButtonAlt],
  templateUrl: './information-card.component.html',
  styleUrls: [
    './information-card.component.ed.scss',
    './information-card.component.essent.scss',
  ],
})
export class InformationCardComponent {
  readonly #jssPlatformService = inject(JssPlatformService);

  readonly title = input.required<TextField>();
  readonly content = input.required<RichTextField>();
  readonly button = input.required<LinkField>();
  readonly image = input<ImageField>();
  readonly aspectRatio = input.required<AspectRatio>();

  readonly isContentEditorActive = this.#jssPlatformService.isEditorActive();

  readonly showImage = computed(
    () =>
      this.image() && (this.isContentEditorActive || this.image()?.value?.src)
  );

  @HostBinding('style.--aspect-ratio')
  protected get computedAspectRatio(): string {
    return this.aspectRatio();
  }
}

export type AspectRatio = '4/3' | '1/1';
